import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

export default function Slider({ imgArr }) {
  return (
    <div className="slide-container" aria-label="Ajanta Cloth House collections">
      <Slide>
        {imgArr.map((slideImage, index) => (
          <div key={index} className="slide-image-wrapper">
            <img
              src={slideImage.url}
              alt={slideImage.alt || `Ajanta Cloth House collection ${index + 1}`}
              className="slide-image"
              loading={index === 0 ? 'eager' : 'lazy'}
            />
          </div>
        ))}
      </Slide>
    </div>
  );
}